import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

export default function CarrierLicenseInfoDialogs({ vm }) {
  const {
    handleUpdateLicenseInfo,
    handleAddLicenseInfo,
    setOpenAddLicenseDialog,
    setOpenEditLicenseDialog,
    isSubmittingLicense,
    openEditLicenseDialog,
    openAddLicenseDialog,
    setNewLicenseType,
    setNewLicenseValue,
    newLicenseType,
    newLicenseValue,
  } = vm;

  return (
    <>
      <Dialog open={openAddLicenseDialog} onClose={() => setOpenAddLicenseDialog(false)}>
        <DialogTitle>Add Carrier Info</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            autoFocus
            margin="dense"
            label="Type"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseType}
            onChange={(e) => setNewLicenseType(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Value"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseValue}
            onChange={(e) => setNewLicenseValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddLicenseDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddLicenseInfo} color="primary" variant="contained" disabled={isSubmittingLicense}>
            {isSubmittingLicense ? <CircularProgress size={24} /> : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditLicenseDialog} onClose={() => setOpenEditLicenseDialog(false)}>
        <DialogTitle>Edit Carrier Info</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            margin="dense"
            label="Type"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseType}
            onChange={(e) => setNewLicenseType(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Value"
            type="text"
            fullWidth
            variant="outlined"
            value={newLicenseValue}
            onChange={(e) => setNewLicenseValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditLicenseDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleUpdateLicenseInfo} color="primary" variant="contained" disabled={isSubmittingLicense}>
            {isSubmittingLicense ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

CarrierLicenseInfoDialogs.propTypes = {
  vm: PropTypes.object.isRequired,
};
